import $ from 'jquery';

// -------- Velocity: bring into THIS module and bridge to jQuery --------
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';

// Ensure we operate on the same jQuery everywhere
if (!window.jQuery) window.jQuery = $;
if (!window.$) window.$ = $;

// Attach a jQuery plugin wrapper if velocity didn’t patch it automatically
if (!$.fn.velocity) {
  $.fn.velocity = function () {
    const args = Array.prototype.slice.call(arguments);
    return this.each(function () {
      Velocity(this, ...args);
    });
  };
}
if (window.jQuery && window.jQuery.fn && !window.jQuery.fn.velocity) {
  window.jQuery.fn.velocity = $.fn.velocity;
}
window.Velocity = window.Velocity || Velocity;

// -------- Bootstrap 5 tooltips (class API) --------
import { Tooltip } from 'bootstrap';

// Cached handles & state
let $body, $window, $document, $siteHeader, $wpAdminBar, $jumpTo;
let headerOffset = 0;
let jumpToOffset = 0;
const breakpointClasses = ['xl','lg','nav','md','sm','xs'];
const breakpoints = {};
let scrollToBodyAnimating = false;

export function init() {
  $body = $(document.body);
  $window = $(window);
  $document = $(document);
  $siteHeader = $('.main-header-wrap');
  $wpAdminBar = $('#wpadminbar');
  $jumpTo = $('.jumpto');

  $body.addClass('loaded');

  // --- Initialize Bootstrap tooltips via class API ---
  initBootstrapTooltips();

  // --- Lazily initialize Tooltipster when legacy markup is detected ---
  // (keeps footprint small & avoids conflicts with Bootstrap)
  initTooltipsterIfPresent();

  // ESC → close search + mobile nav
  $document.on('keyup', (e) => {
    if (e.keyCode === 27) { 
      hideSearch(); h
      ideMobileNav(); 
    }
  });

  // For tabing on Vendor Calendars
  if ($(".calendar-tabs").length) {
    $(".tab_content").hide();
    $(".tab_content:first").show();
    $("ul.tabs li").click(function () {
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");
      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
    });
    $(".tab_drawer_heading").click(function () {
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeIn();
      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });
    $('ul.tabs li').last().addClass("tab_last");
  }

  // Null links
  $('body').on('click', 'a[href="#"]', (e) => e.preventDefault());

  // Smoothscroll links (your pattern)
  $('a.smoothscroll,.smoothscroll a').on('click', function (e) {
    const href = $(this).attr('href').replace(/(https?:)?\/\//, '');
    const anchor = href.replace(/^[^#]*/, '');
    if (href !== anchor) {
      if (location.pathname !== href.replace(anchor, '')) return;
    }
    e.preventDefault();
    const $el = $(anchor).length ? $(anchor) : $('a[name=' + anchor.replace('#','') + ']');
    if ($el && $el.length) scrollBody($el[0]);
  });

  // Mobile arrow
  $('.menu-item-has-children > a').after('<div class="arrowClick"><i class="fa fa-chevron-right"></i></div>');
  $('.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);

    // Toggle sub-menu visibility
    $this.siblings('.sub-menu').slideToggle();

    // Toggle activeMenu class on the arrowClick div
    $this.siblings('.arrowClick').toggleClass('activeMenu');
  });

  // Same-page anchors: cancel native jump; use offset scroller
  $(document).on('click', 'a[href^="#"]:not([href="#"])', function (e) {
    const hash = this.getAttribute('href');
    const $t = $(hash + ', a[name="' + hash.slice(1) + '"]');
    if ($t.length) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', hash);
      else window.location.hash = hash;
      scrollBody($t[0]);
    }
  });

  // Mobile nav + divider line
  $('a.menu-toggle').on('click', toggleMobileNav);
  $('<li class="divider-line"></li>').insertBefore('.site-nav li.divider');

  // Menu hover show/hide (folded Bandicoot)
  $('.menu-item-has-children').on('mouseenter', function () {
    const $a = $(this).children('a[aria-haspopup="true"]');
    $a.attr('aria-expanded', 'true');
    $a.next('.sub-menu').stop(true, true).slideDown();
  }).on('mouseleave', function () {
    const $a = $(this).children('a[aria-haspopup="true"]');
    $a.attr('aria-expanded', 'false');
    $a.next('.sub-menu').stop(true, true).slideUp();
  });

  // More details toggle (missing from folding)
  var $more_details_text;
  if (document.documentElement.lang == 'en-US') {
    $more_details_text = 'More details ';
  } else if (document.documentElement.lang == 'es-MX') {
    $more_details_text = 'Más detalles ';
  } 

  $('.more-details-link').on('click', function(event) {
    event.preventDefault();
    var $this = $(this),
    $vendorDetails = $this.closest('.vendor-grid').find('.vendor-details'),
    $image = $this.find('img');

    if ($vendorDetails.is(':visible')) {
      $vendorDetails.hide();
      $this.contents().filter(function() { return this.nodeType === 3; }).remove();
      $this.prepend($more_details_text);
      $image.removeClass('rotate-180');
    } else {
      $('.vendor-details').hide();
      $('.more-details-link').each(function() {
        $(this).contents().filter(function() { return this.nodeType === 3; }).remove();
        $(this).prepend($more_details_text);
        $(this).find('img').removeClass('rotate-180');
      });

      $vendorDetails.show();
      $this.contents().filter(function() { return this.nodeType === 3; }).remove();
      if (document.documentElement.lang == 'en-US') {
        $this.prepend('Hide details ');
      } else if (document.documentElement.lang == 'es-MX') {
        $this.prepend('Ocultar detalles ');
      }
      $image.addClass('rotate-180');
    }
  });

  // Search toggles (folded Bandicoot)
  $('.search-toggle').on('click', function () {
    $('.primary-nav').toggleClass('hidden');
    $body.toggleClass('search-open');
  });
  $('.search-close').on('click', function () {
    $('.primary-nav').removeClass('hidden');
    hideSearch();
  });

  // Prevent browser auto-scroll caused by anchor focusing
  $(document).on('mousedown', 'a.toggler', function (e) {
    // Prevent focus BEFORE click
    e.preventDefault();
  });

  $(document).on('click', 'a.toggler', function () {
    // Allow click, but never let it remain focused
    try { this.blur(); } catch (_) {}
  });

  $(document).on('focusin', 'a.toggler', function () {
    // Kill accidental focus (keyboard/mouse)
    try { this.blur(); } catch (_) {}
  });

  // Initial layout/offsets
  onResize();

  // Nav collapse on scroll up/down (unchanged)
  initNavCollapse();

  // Jump-to builder + sticky
  initJumpTo();

  // Hash/offset corrections on load/pageshow/hashchange (smooth)
  installHashOffsetHandlers();
}

// ---------- Bootstrap 5 tooltips ----------
function initBootstrapTooltips() {
  const els = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  if (!els.length) return;
  els.forEach((el) => {
    try {
      // Prevent duplicate instances
      Tooltip.getInstance(el) || new Tooltip(el);
    } catch (e) {}
  });
}

// ---------- Tooltipster (lazy) ----------
async function initTooltipsterIfPresent() {
  // Detect likely legacy Tooltipster usage WITHOUT stepping on Bootstrap tooltips
  // - Prefer explicit markers: [data-tooltipster], .js-tooltipster, .tooltipster*
  // - As a fallback, allow `.tooltip` elements WITHOUT data-bs-toggle (old usage from main.js)
  const selector = [
    '[data-tooltipster]',
    '.js-tooltipster',
    '.tooltipster',
    '.tooltipster-parent',
    '.tooltipster-trigger',
    '.tooltip:not([data-bs-toggle="tooltip"])',
    '.tooltip:not([data-bs-toggle="tooltip"]) a',
  ].join(',');

  const nodes = document.querySelectorAll(selector);
  if (!nodes.length) return;

  // Dynamically load Tooltipster (JS + CSS)
  await Promise.all([
    import('tooltipster/dist/js/tooltipster.bundle.min.js'),
    import('tooltipster/dist/css/tooltipster.bundle.min.css'),
  ]);

  // Initialize with your old options from main.js
  const $targets = $('.tooltip:not([data-bs-toggle="tooltip"]), [data-tooltipster], .js-tooltipster, .tooltipster, .tooltipster-parent, .tooltipster-trigger, .tooltip:not([data-bs-toggle="tooltip"]) a');

  if ($targets.length && $.fn.tooltipster) {
    $targets.tooltipster({
      side: 'bottom',
      theme: 'ilsfa',
      distance: 0,
      interactive: true,
      trigger: 'custom',
      triggerOpen: {
        mouseenter: true,
        tap: true,
      },
      triggerClose: {
        mouseleave: true,
        scroll: true,
        tap: true,
      },
    });
  }
}

export function onResize() {
  const indicator = document.querySelector('#breakpoint-indicator');
  const bp = (indicator
    ? window.getComputedStyle(indicator, ':after').getPropertyValue('content').replace(/['"]/g, '')
    : '');
  breakpointClasses.forEach((name, i) => {
    breakpoints[name] = (bp === name || (i > 0 && breakpoints[breakpointClasses[i-1]]));
  });
  setHeaderOffset();
  setJumpToPosition();
}

/**
 * Smoothly scrolls to target with header/jumpto offset.
 * Accepts: CSS selector, DOM node, or jQuery object.
 * Uses Velocity if present; otherwise falls back to native smooth scroll.
 */
export function scrollBody(target, duration = 500, delay = 0) {
  setHeaderOffset();

  // Normalize to a jQuery object
  let $target;
  if (typeof target === 'string') {
    $target = $(target + ',a[name="' + target.replace('#','') + '"]');
  } else if (target && target.nodeType === 1) {
    $target = $(target);
  } else if (target && target.jquery) {
    $target = target;
  } else {
    return; // nothing to scroll to
  }
  if (!$target.length) return;

  hideMobileNav();
  scrollToBodyAnimating = true;

  let offset = 20 + headerOffset;
  if ($('.jumpto').length) offset += $('.jumpto').outerHeight();

  const hasVelocity = !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.velocity);

  if (hasVelocity) {
    // Use Velocity on the jQuery object
    $target.velocity('scroll', {
      duration,
      delay,
      offset: -offset,
      complete: () => setTimeout(() => { scrollToBodyAnimating = false; }, 150),
    }, 'easeOutSine');
  } else {
    // Native fallback
    const top = $target.offset().top - offset;
    window.scrollTo({ top, behavior: 'smooth' });
    setTimeout(() => { scrollToBodyAnimating = false; }, duration + 150);
  }
}

// Expose for maps modules
window.ILSFA_scrollBody = scrollBody;

function hideSearch() { $body.removeClass('search-open'); hideMobileNav(); }
function toggleMobileNav() { $body.toggleClass('menu-open'); onResize(); }
function hideMobileNav() { $body.removeClass('menu-open'); onResize(); }

function setHeaderOffset() {
  const $h = $('.main-header-wrap');
  const $bar = $('#wpadminbar');
  headerOffset = $h.outerHeight();
  if ($bar.length && $bar.css('position') === 'fixed') headerOffset += $bar.outerHeight();

  const $jump = $('.jumpto');
  jumpToOffset = $jump.length ? $jump.outerHeight() : 0;

  // expose read-only for maps modules
  window._ILSFA_getHeaderOffset = () => headerOffset;
  window._ILSFA_getJumpToOffset = () => jumpToOffset;
}

function setJumpToPosition() {
  const $jump = $('.jumpto');
  if (!$jump.length) return;
  if ($jump.is('.stuck')) {
    if ($('body').hasClass('bright-neighborhoods') || $('body').hasClass('bright-neighborhoods-espanol')) {
      $jump.css('top', headerOffset + 31);
    } else {
      $jump.css('top', headerOffset);
    }
  } else {
    $jump.css('top', '');
  }
}

function initNavCollapse() {
  let didScroll = false;
  let lastScrollTop = 0;
  const scrollUpDelta = 150;
  const scrollDownDelta = 100;

  $(window).on('scroll', () => { didScroll = true; });

  setInterval(() => {
    if (!didScroll) return;
    $body.addClass('has-scrolled');
    const st = $window.scrollTop();

    if (st < scrollDownDelta) $body.removeClass('has-scrolled');
    if (Math.abs(lastScrollTop - st) <= scrollDownDelta) { return; }

    if (st > lastScrollTop) {
      $('.main-header-wrap').removeClass('nav-down').addClass('collapsed');
      onResize();
    } else {
      if (!scrollToBodyAnimating && (st <= scrollUpDelta || Math.abs(lastScrollTop - st) >= scrollUpDelta)) {
        $('.main-header-wrap').removeClass('collapsed').addClass('nav-down');
        onResize();
      }
    }
    lastScrollTop = st;
    didScroll = false;
  }, 150);
}

function slugify(text) {
  return text.replace(/[^a-zA-Z0-9\-\s]/g, '').toLowerCase().replace(/\s/g, '-');
}

function initJumpTo() {
  const $jump = $('.jumpto');
  if (!$jump.length) return $jump.remove();

  const links = [];
  $jump.find('li').remove();

  $('main .page-content h2, [data-jumpto]').each(function () {
    if (!$(this).attr('data-jumpto-hash')) {
      const title = $(this).attr('data-jumpto') || $(this).text();
      const hash = slugify(title);
      $(this).attr({'data-jumpto-hash': hash, id: hash});
      links.push({ title, url: '#' + hash, el: this });
    }
  });

  if ($('body').hasClass('page-template-page-for-vendors-child')) {
    $('input[type=checkbox]').each(function () {
      if ($(this).attr('data-check-hash') === window.location.hash.substring(1)) {
        $(this).prop('checked', !$(this).prop('checked')).trigger('change');
      }
    });
  }

  if (!links.length) return $jump.remove();

  const hasVelocity = !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.velocity);
  $jump.addClass('loaded')
      .find('.jumpto-title,.jumpto-toggle')
      .on('click', (e) => {
        e.preventDefault();
        const opening = !$jump.hasClass('-active');
        $jump.toggleClass('-active');
        if (hasVelocity) {
          $jump.find('ul').velocity(opening ? 'slideDown' : 'slideUp', { duration: 150 });
        } else {
          if (opening) $jump.find('ul').slideDown(150);
          else $jump.find('ul').slideUp(150);
        }
      });

  $.each(links, (i, item) => {
    const $li = $('<li><a href="' + item.url + '">' + item.title + '</a></li>')
      .appendTo($jump.find('ul'))
      .on('click', (e) => {
        e.preventDefault();
        scrollBody(item.el);
        if (!breakpoints.md) $jump.find('.jumpto-toggle').trigger('click');
      });

    if (hasVelocity) {
      $li.hide().velocity('transition.slideLeftIn', {
        easing: 'easeOutSine',
        duration: 200,
        delay: (i - 1) * 50,
        display: 'inline-block',
      });
    } else {
      $li.show();
    }
  });

  new window.Waypoint.Sticky({
    element: $jump[0],
    wrapper: '<div class="jumpto-sticky-wrapper" />',
    handler: () => onResize(),
    offset: headerOffset
  });

  setHeaderOffset();
}

/**
 * Smooth hash behavior:
 * - On load/pageshow with a hash: jump back to top, then animate to target once ready.
 * - On hashchange: animate from current position instead of snapping.
 */
function installHashOffsetHandlers() {
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // On load/pageshow
  const runOnce = () => {
    const hashTarget = (sessionStorage.getItem('scrollHash') || window.location.hash);
    if (!hashTarget) return;

    // Prevent native snap
    try { window.scrollTo(window.pageXOffset, 0); } catch (e) {}

    let tries = 0, max = 12;
    const tick = () => {
      setHeaderOffset();
      const $t = $(hashTarget + ', a[name="' + hashTarget.replace('#','') + '"]');
      if ($t.length && $t.is(':visible')) {
        scrollBody($t[0]); // animate
        try { sessionStorage.removeItem('scrollHash'); } catch (e) {}
        return;
      }
      if (++tries < max) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  window.addEventListener('load', runOnce, { once: true });
  window.addEventListener('pageshow', runOnce);

  // On hashchange: smooth
  window.addEventListener('hashchange', function () {
    if (!window.location.hash) return;
    const hash = window.location.hash;
    const yBefore = window.pageYOffset;
    requestAnimationFrame(() => {
      try { window.scrollTo(window.pageXOffset, yBefore); } catch (e) {}
      const $t = $(hash + ', a[name="' + hash.slice(1) + '"]');
      if ($t.length) scrollBody($t[0]);
    });
  });

  // Expose helper
  window.ILSFA_scrollHashCorrect = (animate = true) => {
    const hashTarget = (sessionStorage.getItem('scrollHash') || window.location.hash);
    if (!hashTarget) return;
    const $t = $(hashTarget + ', a[name="' + hashTarget.replace('#','') + '"]');
    if ($t.length) {
      if (animate) scrollBody($t[0]);
      else {
        setHeaderOffset();
        const safety = 20 + ($('.jumpto').length ? $('.jumpto').outerHeight() : 0);
        const top = $t.offset().top - (headerOffset + safety);
        window.scrollTo({ top, behavior: 'auto' });
      }
    }
  };
}
